import axios from "axios";

export const SyncFullMexPMTaskOperations = () => {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.get(process.env.REACT_APP_API_GLOBAL_URL + `preventative-maintenance-task/sync-full`,  {
      headers,
    });
  };